export const API_KEY = process.env.REACT_APP_API_KEY;
export const API_HASH = process.env.REACT_APP_API_HASH;